import { useEffect, useState, type ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { getCurrentUser } from "./auth-service";

export function PublicRoute({ children }: { children: ReactNode }) {
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    getCurrentUser()
      .then((u) => {
        if (u) navigate("/dashboard", { replace: true });
      })
      .catch(() => {
        // Not authenticated, stay on page
      })
      .finally(() => setChecking(false));
  }, [navigate]);

  if (checking) return null;
  return <>{children}</>;
}
